export default class Nav{

    constructor(){
        
        this.navTrigger = $('.js__nav-display')
        this.mobileNav = $('.mobileNav')
        this.closeMobileNavBtn = $('.js__close-nav')
        this.eventListener()

    }

    eventListener(){

        this.navTrigger.on('click', () => {
            this.mobileNavFnc()
        })

        this.closeMobileNavBtn.on('click', () => {
            this.closeMobileNav()
        })

        $(window).on('scroll', () => {
            this.scrollActive()
        })

    }

    mobileNavFnc(){
        $('body').addClass('no-scroll')
        this.mobileNav.addClass('visible')
    }

    closeMobileNav(){
        $('body').removeClass('no-scroll')
        this.mobileNav.removeClass('visible')
    }

    scrollActive(){
        if($(window).scrollTop() > 100){
            $('.header').addClass('sm-header')
        } else {
            $('.header').removeClass('sm-header')
        }
    }

}